<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<div mat-dialog-title>
  @if (data.evaluation.id) {
  <span>Edit Evaluation</span>
  }
  @if (!data.evaluation.id) {
  <span>Add Evaluation</span>
  }
  <button mat-icon-button (click)="handleEditComplete(false)" title="Cancel" class="close-button" tabindex="-1">
    <mat-icon class="mdi-24px self-center" fontIcon="mdi-close-circle-outline"></mat-icon>
  </button>
</div>
@if (data && data.evaluation) {
  <div mat-dialog-content>
    <div class="add-margin">
      <div>
        <mat-form-field class="description-field full-width">
          <mat-label>Evaluation Description</mat-label>
          <input matInput [(ngModel)]="data.evaluation.description" [disabled]="!data.canEdit" />
        </mat-form-field>
      </div>
    </div>
    <div class="add-margin">
      <div>
        <mat-form-field class="description-field full-width">
          <mat-label>Scoring Model</mat-label>
          <mat-select placeholder="Please select a scoring model" [(value)]="data.evaluation.scoringModelId"
            (click)="$event.stopPropagation()" [disabled]="data.isExisting || !data.canEdit">
            @for (scoringModel of data.scoringModels; track scoringModel) {
              <mat-option [value]="scoringModel.id">
                {{ scoringModel.description }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="add-margin">
      <div>
        <mat-form-field class="description-field full-width">
          <mat-label>Evaluation Status</mat-label>
          <mat-select placeholder="Select a Status" [(value)]="data.evaluation.status" (click)="$event.stopPropagation()" [disabled]="!data.canEdit">
            @for (status of data.itemStatuses; track status) {
              <mat-option [value]="status">
                {{ status }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="add-margin">
      <div>
        <mat-form-field class="description-field full-width">
          <mat-label>Gallery Exhibit ID</mat-label>
          <input matInput [(ngModel)]="data.evaluation.galleryExhibitId" [disabled]="!data.canEdit" />
        </mat-form-field>
      </div>
    </div>
    <div class="add-margin">
      <div>
        <mat-form-field class="description-field">
          <mat-label>Current Move</mat-label>
          <input matInput [(ngModel)]="data.evaluation.currentMoveNumber" [disabled]="!data.canEdit" />
        </mat-form-field>
      </div>
    </div>
    <div class="add-margin">
      <div>
        <mat-form-field class="datetime-field">
          <mat-label>Situation Date / Time</mat-label>
          <input matInput [ngxMatDatetimePicker]="picker"
            [formControl]="situationDateFormControl" (inputChange)="saveEvaluation('situationDate')"
            (dateChange)="saveEvaluation('situationDate')" style="display: none;">
          <span (click)="data.canEdit && picker.open()">
            {{data.evaluation.situationTime | date: 'dd MMM yyyy HH:mm'}} {{ getTimezoneAbbr() }}
          </span>
          <mat-datepicker-toggle matSuffix title="Choose Date/Time" [for]="$any(picker)" [disabled]="!data.canEdit">
          </mat-datepicker-toggle>
          <ngx-mat-datetime-picker #picker [showSpinners]=true [showSeconds]=false [stepHour]=1 [stepMinute]=5
            [stepSecond]=1 [touchUi]=false [enableMeridian]=true [disableMinute]=false [hideTime]=false [color]="'warn'">
            <ngx-mat-datepicker-actions>
              <button mat-stroked-button ngxMatDatepickerApply>Save</button>
              <button mat-stroked-button ngxMatDatepickerCancel>Cancel</button>
            </ngx-mat-datepicker-actions>
          </ngx-mat-datetime-picker>
        </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <mat-label class="gray">Situation Description</mat-label>
        <angular-editor [placeholder]="'Enter situation description here...'"
        [(ngModel)]="data.evaluation.situationDescription" [config]="editorConfig"></angular-editor>
      </div>
      <div class="cssLayoutRowStartCenter bottom-button">
        <div class="delete-button">
          <button mat-stroked-button (click)="handleEditComplete(true)" [disabled]="!errorFree() || !data.canEdit"
          style="margin-left: 40px;">Save</button>
        </div>
        <div class="delete-button">
          <button mat-stroked-button (click)="handleEditComplete(false)">Cancel</button>
        </div>
      </div>
    </div>
  }
